<template>
    <div class="notification" :class="{targeted: item.targeted}">
        <div class="notification-heading user-action" style="display:flex;justify-content:space-between;" @click.stop="triggerTarget">
            <slot name="title">
                <div class="" style="flex:1">{{item.title}} <a v-if="hasLink" :href="item.link"><span class="glyphicon glyphicon-globe"></span></a></div>
            </slot>
            <div class="text-right" style="flex:0 1 15%"><span @click.stop="triggerDelete" class="glyphicon glyphicon-trash" title="Remove Notification"></span></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        name: 'NotificationStandard',
        data () {
            return {
            }
        },
        computed: {
            hasLink: function () {
                return (this.item.link !== undefined && this.item.link !== null)
            }
        },
        methods: {
            triggerTarget: function () {
                this.$emit('notification:targeted', this.item)
            },
            triggerDelete: function (e) {
                this.$emit('notification:deleted', this.item)
            }
        },
        components: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Standard.vue?4e701322